export enum TrayIcon {
  Disconnected,
  Green,
  Yellow,
  Red,
  Error,
}
